
// import { Suspense } from 'react';
import './App.css';
import './Call.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import 'animate.css';
import './features/admin/admin.css'
import 'react-responsive-modal/styles.css';
import './features/reports/components/report.css'
import 'react-modern-drawer/dist/index.css'
import 'react-phone-input-2/lib/style.css';
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-datepicker/dist/react-datepicker.css';
import './styles/DashboardCalender.css'
import './styles/icons.css'
import './styles/icons.css'
import { useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import CallRinging from './components/Call_window/Popup/CallRinging';
import SocketClient from "./Utils/SocketClient";
import useViewportHeight from 'shared/hooks/useViewportHeight';
import { ErrorBoundary } from './components/ErrorBoundary';
import { storage, KEYS } from 'Utils/storage';
import { applyTheme, getTheme } from 'Utils/theme';

applyTheme(getTheme());

function App() {
  useViewportHeight();
  const { callringpopup, user: reduxUser, allUsers, updateVersion_data } = useSelector(state => state.message);
  const localUser = storage.get(KEYS.LOCAL_USER);
  const user = reduxUser || JSON.parse(localUser);

  return (
    <>
      {user && allUsers && <SocketClient user={user} users={allUsers} />}
      {callringpopup.status && <CallRinging user={user} callringpopup={callringpopup} />}
      {updateVersion_data === "yes" ? (
        <div className="backwrap">
          <div className="upgrade_section">
            <div className="reloadIcon"></div>
            <div className="upgrade_title"> New application version detected </div>
            <div className="upgrade_btn">
              <button
                name="upgrade_btn"
                onClick={() => window.location.reload(true)}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <Toaster />
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </>
  );
}

export default App;
